import translation from 'locales/translation';
import { Input } from 'plataforma-fundacao-componentes';
import { InputProps } from 'plataforma-fundacao-componentes/dist/components/input/Input';
import { Controller, useFormContext } from 'react-hook-form';
import { AdicionarConvidadoSchemaType } from 'schema/adicionar-convidado.schema';

const language = translation.Assessor.Modal.AdicionarConvidado;

export default function NameField({ ...rest }: InputProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext<AdicionarConvidadoSchemaType>();

  return (
    <Controller
      name={'name'}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Input
          data-testid='input-adicionar-convidado'
          label={language.input.label}
          autoFocus
          placeholder={language.input.placeholder}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          error={!!errors.name}
          helperText={errors.name?.message?.toString() ?? ''}
          onKeyPress={(event) => {
            if (!/[aA-zZ\s]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          {...rest}
        />
      )}
    />
  );
}
